import Joi from "joi";

import { safeLocalStorage } from "helpers/localStorage";

import { isSSR } from "./environment";

export const EMAIL_VALIDATION = Joi.string().email({ tlds: { allow: false } });

const VERIFICATION_EMAIL_KEY = "elk_logistics_verification_email";

export const getVerificationEmail = () => {
  if (isSSR()) {
    return null;
  }
  return safeLocalStorage.getItem(VERIFICATION_EMAIL_KEY);
};

export const setVerificationEmail = (email: string) => {
  if (isSSR()) {
    return;
  }
  safeLocalStorage.setItem(VERIFICATION_EMAIL_KEY, email);
};

export const clearVerificationEmail = () => {
  if (isSSR()) {
    return;
  }
  safeLocalStorage.removeItem(VERIFICATION_EMAIL_KEY);
};
